import type { User } from '@web/store/types/modules/user'

/**
 * Пользователь принадлежит сегменту ФФ/НМС (MOB-401).
 * segmentId приходит из external-config (`segments.ffNms`); значение 0
 * означает «ключ не настроен» — тогда сценарий не активируется ни для кого.
 */
export function selectHasFfNmsSegment (
  user: User | undefined | null,
  segmentId: number
): boolean {
  if (!segmentId) return false
  return user?.segments?.some((segment: Segment) => segment.id === segmentId) ?? false
}
